<div class="layout pt-6 pb-12 lg:pb-24">
  <div class="lg:grid grid-cols-12 gap-2 md:gap-4 relative">

    <div class="h-[290px] md:h-[500px] relative p-20 col-span-8 mb-5 md:mb-0">
      @if (images()[0]; as image) {
        <img class="object-cover rounded-lg"
             fill="" sizes="50vw"
             [alt]="image.alt"
             [ngSrc]="image.media"
        >
      } @else {
        <img class="object-cover rounded-lg"
             fill="" sizes="50vw"
             [alt]="'product/'+product().id+'/name' | translate"
             ngSrc="assets/images/placeholder.webp"
        >
      }
    </div>
    <div class="h-[250px] md:h-[500px] relative col-span-4 hidden lg:block">
      @if (images()[1]; as image) {
        <img class="object-cover rounded-lg"
             fill="" sizes="50vw"
             [alt]="image.alt"
             [ngSrc]="image.media"
        >
      } @else {
        <img class="object-cover rounded-lg"
             fill="" sizes="50vw"
             [alt]="'product/'+product().id+'/name' | translate"
             ngSrc="assets/images/placeholder.webp"
        >
      }

    </div>
    <button
      (click)="drawerService.open({component: GalleryComponent, inputs: { images: images() }})"
      class="flex bg-white absolute bottom-2 md:bottom-6 right-2 md:right-6 py-2 px-4 rounded-lg items-center gap-2">
      @if (giftMode()) {
        <img class="w-4" ngSrc="assets/icons/dark/gallery.svg" alt="" width="35" height="40">
      } @else {
        <img class="w-4" ngSrc="assets/icons/dark/gallery.svg" alt="" width="35" height="40">
      }
      <p [class.text-100ciels-300]="!giftMode()" [class.text-100cielsGift-100]="giftMode()"
         class="font-semibold">{{ 'morePhotos' | translate }}</p>
    </button>

  </div>

  <div class="flex flex-col-reverse gap-16 md:gap-0 md:flex-col lg:grid grid-cols-12 mt-16">
    <div class="col-span-8 lg:pr-20">
      <div class="flex gap-4">
        <img alt="" class="h-8" height="32" ngSrc="assets/icons/dark/location.svg" width="32">
        <p class="text-xl text-gray-600">{{ 'les100cielsCenter' | translate }} {{ center()?.name }}</p>
      </div>
      <div class="md:flex items-center justify-between">
        <h1
          [class.text-100ciels-300]="!giftMode()" [class.text-100cielsGift-100]="giftMode()"
          class="font-semibold mt-4 mb-4 md:mb-0 text-4xl leading-tight uppercase font-montserrat">{{ 'product/' + product().id + '/name' | translate }}</h1>
        <div class="flex gap-4">
          <button
            (click)="drawerService.open({component: ShareSocialsComponent, inputs: undefined, style: 'transparent', socials: true});"
            (keyup.enter)="emulateClick($event)"
            class="p-4 rounded-full bg-gray-200 hover:bg-gray-100">
            <img alt="" class="w-4" height="32" ngSrc="assets/icons/dark/share.svg"
                 width="32">
          </button>
        </div>
      </div>

      <app-inner-html [html]="productService.translate(siteService.center()?.id, product().id, 'longDescription')"
                      classes="text-100ciels-500 my-5"></app-inner-html>

      @if (selectedProduct().type === ProductType.Standard) {
        @if (!giftMode()) {
          @if (planningDisplayed()) {
            <app-spa-booking [center]="siteService.center()!" [product]="selectedProduct()"
                             (validated)="validatePlanning($event)" (cancelled)="hidePlanning()"
                             (nbInvitations)="setQuantity($event + 1)"
            ></app-spa-booking>
          } @else {
            <div class="w-full mt-8">
              @if (selectedSpaBooking(); as appointment) {
                <p
                  class="rounded-lg bg-100ciels-500 text-white text-lg font-bold text-center whitespace-pre-line mx-10 my-4 p-4 ">
                  {{
                    'bookedFor.v2' | translate : {
                      date: (appointment.date | date),
                      time: isRituel() ? appointment.products[1].start : appointment.products[0].start
                    }
                  }}
                </p>
              } @else {
                <button class="w-full md:w-1/2 md:ml-[25%] justify-center text-sm mt-8" appHoverGradient
                        (click)="displayPlanning()">
                  {{ 'showPlanning' | translate }}
                </button>
              }
            </div>
          }
        }
      }
      <app-inner-html [html]="productService.translate(siteService.center()?.id, product().id, 'longDescription2')"
                      classes="text-100ciels-500 mt-10"></app-inner-html>
      <div class="flex md:flex-row flex-col text-100ciels-500 font-semibold gap-6 lg:gap-10 mt-10">
        <p (click)="tab.set('goodToKnow')"
           (keyup.enter)="emulateClick($event)"
           [ngClass]="{'text-100ciels-300': tab() === 'goodToKnow'}"
           class="cursor-pointer font-bold group hover:text-100ciels-300"
           tabindex="0">
          <svg [class.-rotate-90]="tab() !== 'goodToKnow'"
               [class.stroke-gray-300]="tab() !== 'goodToKnow'"
               class="size-4 inline fill-none transition-all duration-150 mr-2 stroke-100ciels-300 group-hover:stroke-100ciels-300"
               viewBox="0 0 60 60">
            <path d="m7.81,20.49l22.19,22.19,22.19-22.19" fill="none" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="10"/>
          </svg>
          {{ 'goodToKnow' | translate }}

        </p>
        <p (click)="tab.set('bePrepared')"
           (keyup.enter)="emulateClick($event)"
           [ngClass]="{'text-100ciels-300': tab() === 'bePrepared'}"
           class="cursor-pointer font-bold hover:text-100ciels-300"
           tabindex="0">
          <svg [class.-rotate-90]="tab() !== 'bePrepared'"
               [class.stroke-gray-300]="tab() !== 'bePrepared'"
               class="size-4 inline fill-none transition-all duration-150 mr-2 stroke-100ciels-300 group-hover:stroke-100ciels-300"
               viewBox="0 0 60 60">
            <path d="m7.81,20.49l22.19,22.19,22.19-22.19" fill="none" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="10"/>
          </svg>
          {{ 'bePrepared' | translate }}
        </p>
        <p (click)="tab.set('access')"
           (keyup.enter)="emulateClick($event)"
           [ngClass]="{'text-100ciels-300': tab() === 'access'}"
           class="cursor-pointer font-bold hover:text-100ciels-300"
           tabindex="0">
          <svg [class.-rotate-90]="tab() !== 'access'"
               [class.stroke-gray-300]="tab() !== 'access'"
               class="size-4 inline fill-none transition-all duration-150 mr-2 stroke-100ciels-300 group-hover:stroke-100ciels-300"
               viewBox="0 0 60 60">
            <path d="m7.81,20.49l22.19,22.19,22.19-22.19" fill="none" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="10"/>
          </svg>
          {{ 'access' | translate }}
        </p>
      </div>
      <hr class="text-100ciels-500 my-10">
      <app-inner-html [html]="productService.translate(siteService.center()?.id, product().id, tab())"
                      classes="text-100ciels-500 mb-10"></app-inner-html>
    </div>
    <div class="col-span-4" id="cartCard">
      <div class="rounded-lg border-2 border-gray-200 p-8">
        @if (price(); as p) {
          <div class="font-semibold text-xl flex flex-col">
            @if (p.promo && p.fullPrice) {
              <span class="mr-4 text-100ciels-300 line-through">
                {{ p.fullPrice | currency }}
              </span>
            }
            <span
              [class.text-100cielsGift-500]="p.promo || giftMode()"
              [class.text-100ciels-300]="!p.promo && !giftMode()">
                {{ p.price | currency }}
              </span>
          </div>
        }
        @if (isGroup) {
          <p class="mt-4 ml-2 font-semibold text-100ciels-500 text-xs">{{ 'selectVariant' | translate }}</p>
          <div appAutoClose="always" class="relative mt-2">
            <button type="button"
                    class="bg-gray-100 py-5 px-4 pr-10 md:px-7 hover:bg-gray-200 duration-200 cursor-pointer relative w-full rounded-md text-left text-gray-900 focus:outline-none">
            <span class="flex items-center justify-between">

              <p
                class="truncate text-100ciels-500 font-semibold text-base lg:text-lg mr-4 md:mr-6">
               {{ ('product/' + selectedProduct().id + '/shortName' | translate) || ('product/' + selectedProduct().id + '/name' | translate) }}
              </p>
            </span>
              <span class="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-6">
                     <img ngSrc="assets/icons/dark/down.svg" width="60" height="60" alt="" class="h-4 w-4">
            </span>
            </button>
            <ul
              class="hidden absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
              tabindex="-1" role="listbox">

              @for (p of products(); track p.id) {
                <li (click)="selectedProduct.set(p)"
                    (keyup.enter)="emulateClick($event)"
                    class="text-gray-900 hover:bg-gray-100 relative select-none py-4 px-3 md:px-5 cursor-pointer"
                    role="option"
                    tabindex="0"
                    [attr.aria-selected]="selectedProduct().id === p.id">
                  <div class="flex items-center">
                <span
                  class="text-lg text-100ciels-500 ml-3 block truncate">
                  {{ ('product/' + p.id + '/shortName' | translate) || ('product/' + p.id + '/name' | translate) }}
                </span>
                  </div>
                </li>
              }
            </ul>
          </div>
        }
        @if (giftMode()) {
          <div class="relative mt-4">
            <div
              class="bg-gray-100 py-4 px-4 pr-10 md:px-7 hover:bg-gray-200 duration-200 cursor-pointer relative w-full rounded-md text-left text-gray-900 focus:outline-none">
            <span class="flex items-center justify-between">
              <div class="w-12 uppercase text-100ciels-500">
             {{ 'quantity' | translate }}
              </div>
              <div class="relative flex items-center">
                <button (click)="updateQuantity(-1)"
                        (keyup.enter)="emulateClick($event)"
                        class="flex-shrink-0 inline-flex items-center justify-center rounded-md h-5 w-5 focus:outline-none"
                        type="button">
                    <svg aria-hidden="true" class="w-2.5 h-2.5 text-100ciels-500" fill="none"
                         viewBox="0 0 18 2" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1h16" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                              stroke-width="2"/>
                    </svg>
                </button>
                <input (ngModelChange)="setQuantity($event)"
                       [ngModel]="quantity()"
                       class="flex-shrink-0 border-0 bg-transparent focus:outline-none focus:ring-0 max-w-16 text-100ciels-500 font-semibold text-center"
                       required
                       type="text">
                <button (click)="updateQuantity(1)"
                        (keyup.enter)="emulateClick($event)"
                        class="flex-shrink-0 inline-flex items-center justify-center rounded-md h-5 w-5"
                        type="button">
                    <svg aria-hidden="true" class="w-2.5 h-2.5 text-100ciels-500" fill="none"
                         viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 1v16M1 9h16" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                              stroke-width="2"/>
                    </svg>
                </button>
              </div>
            </span>
            </div>
          </div>
        }

        @if (giftMode()) {
          <button appHoverGradientGreen
                  [appProgressClick]="addToCart"
                  class="big-btn hidden md:block bg-100cielsGift-100">
            {{ 'addToCart' | translate }}
          </button>
        }

        <div class="mt-12 flex justify-between text-100ciels-500">
          @if (price(); as p) {
            <p class="">{{ p.price | currency }} x {{ quantity() }}</p>
          }
          <p class="font-semibold">{{ total() | currency }}</p>
        </div>
        @if (selectedSpaBooking(); as appointment) {
          <p class="text-100ciels-500 text-sm whitespace-pre-line">
            {{
              'bookedFor.v2' | translate : {
                date: (appointment.date | date),
                time: isRituel() ? appointment.products[1].start : appointment.products[0].start
              }
            }}
          </p>
        }
        <hr class="mt-10 mb-3 text-100ciels-500">
        <div class="mt-4 flex justify-between text-100ciels-500">
          <p class="">{{ 'totalWithTaxes' | translate }}</p>
          <p class="font-semibold">{{ total() | currency }}</p>
        </div>
        <div class="mt-1 flex justify-between text-100ciels-500">
          <p class="text-sm">{{ 'taxes' | translate }}</p>
          <p class="text-sm">{{ taxes() | currency }}</p>
        </div>
      </div>


      @if (addedToCard()) {
        @if (!giftMode()) {
          <div><a appHoverGradient routerLink="/offers" class="big-btn">
            {{ 'resumeShopping' | translate }}
          </a>
            <a appHoverGradient routerLink="/checkout"
               class="big-btn bg-white border hover:text-white text-100ciels-300 border-100ciels-300">
              {{ 'goToCart' | translate }}
            </a></div>
        } @else {
          <div><a appHoverGradientGreen routerLink="/offers" class="big-btn bg-100cielsGift-100">
            {{ 'resumeShopping' | translate }}
          </a>
            <a appHoverGradientGreen routerLink="/checkout"
               class="big-btn bg-white border hover:text-white text-100cielsGift-100 border-100cielsGift-100">
              {{ 'goToCart' | translate }}
            </a></div>
        }

      }

    </div>

  </div>

</div>
<app-products content="minimal" id="offers"/>
<div
  class="md:hidden flex px-6 py-4 gap-5 justify-between items-center fixed bottom-[68px] border-y border-gray-200 bg-white z-10 w-full">

  <div>
    @if (price(); as p) {
      <div class="font-semibold text-xl flex flex-col">
        @if (p.promo && p.fullPrice) {
          <span class="text-100ciels-300 line-through">
            {{ p.fullPrice * quantity() | currency }}
          </span>
        }
        <span
          [class.text-100cielsGift-500]="p.promo || giftMode()"
          [class.text-100ciels-300]="!p.promo && !giftMode()">
          {{ total() | currency }}
        </span>
      </div>
    }
  </div>
  @if (giftMode()) {
    <div class="relative flex gap-2 items-center">
      <button (click)="updateQuantity(-1)"
              (keyup.enter)="emulateClick($event)"
              class="rounded-md bg-white px-3.5 py-3.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              type="button">
        <svg aria-hidden="true" class="w-2.5 h-2.5 text-100ciels-500" fill="none"
             viewBox="0 0 18 2" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1h16" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                stroke-width="2"/>
        </svg>
      </button>
      <span class="text-100ciels-500 text-base font-semibold">{{ quantity() }}</span>
      <button (click)="updateQuantity(1)"
              (keyup.enter)="emulateClick($event)"
              class="rounded-md bg-white px-3.5 py-3.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              type="button">
        <svg aria-hidden="true" class="w-2.5 h-2.5 text-100ciels-500" fill="none"
             viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 1v16M1 9h16" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                stroke-width="2"/>
        </svg>
      </button>
    </div>
  }
  <div>
    @if (addedToCard()) {
      <a appHoverGradient routerLink="/checkout"
         class="main-btn text-center bg-white text-100ciels-300 border  hover:text-white"
         [ngClass]="giftMode() ? 'border-100cielsGift-100 hover:bg-100cielsGift-100' : 'border-100ciels-300 hover:bg-100ciels-300'">
        {{ 'goToCart' | translate }}
      </a>
    }
    @if (giftMode()) {
      <button appHoverGradientGreen
              [disabled]="planningDisplayed()"
              [appProgressClick]="addToCart"
              class="main-btn bg-100cielsGift-100">
        {{ 'addToCart' | translate }}
      </button>
    }
  </div>
</div>
